module.exports = __webpack_public_path__ + "static/img/zl2.ea848ad9.png";